import { memo } from 'react'

import notFoundSvg from 'common/assets/img/illustration/404.svg'
import LostInSpace from 'common/components/lostInSpace'

const NotFound = () => (
  <LostInSpace>
    <img className="image-404" src={notFoundSvg} />
  </LostInSpace>
)

export default memo(NotFound)
